import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  payment_methods: [],
};

const getters = {
  allPaymentMethods: (state) => state.payment_methods,
};

const actions = {
  async fetchPaymentMethods({ commit }, params = {}) {
    try {
      commit("resetPaymentMethods");
      const response = await axios.get("/payment-method", {
        params: prm(params),
      });
      let data = response.data;
      const payment_methods =
        data && data.data.filter((item) => item.name !== "Hutang");

      data = {
        ...data,
        data: payment_methods,
      };

      console.log("payment_methods store: ", data);
      commit("setPaymentMethods", data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch payment_methods:", error);
    }
  },
  async createPaymentMethod({ commit }, payment_method) {
    try {
      const response = await axios.post("/payment-method", payment_method);
      commit("addPaymentMethod", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create payment_method:", error);
      throw error;
    }
  },
  async fetchPaymentMethodById(_, id) {
    try {
      const response = await axios.get(`/payment-method/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch payment_method:", error);
      throw error;
    }
  },
  async updatePaymentMethod({ commit }, payment_method) {
    try {
      const response = await axios.put(
        `/payment-method/${payment_method.id}`,
        payment_method
      );
      commit("updatePaymentMethod", response.data);
    } catch (error) {
      console.error("Failed to update payment_method:", error);
      throw error;
    }
  },
  async deletePaymentMethodById({ commit }, id) {
    try {
      const response = await axios.delete(`/payment-method/${id}`);
      commit("removePaymentMethod", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete payment_method:", error);
      throw error;
    }
  },
};

const mutations = {
  setPaymentMethods(state, payment_methods) {
    state.payment_methods = payment_methods.data; // Ensure this matches your API's response structure
  },
  addPaymentMethod(state, payment_method) {
    state.payment_methods.push(payment_method);
  },
  updatePaymentMethod(state, updatedPaymentMethod) {
    const index = state.payment_methods.findIndex(
      (payment_method) => payment_method.id === updatedPaymentMethod.id
    );
    if (index !== -1) {
      state.payment_methods.splice(index, 1, updatedPaymentMethod);
    }
  },
  removePaymentMethod(state, id) {
    state.payment_methods = state.payment_methods.filter(
      (payment_method) => payment_method.id !== id
    );
  },
  resetPaymentMethods(state) {
    state.payment_methods = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
